import React, { useContext, useState, useEffect } from "react";
import styles from "../../styles/AddSighting.module.css";
import { MapContainer, TileLayer, Marker, Popup, useMapEvents } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { UserContext } from "../context/user/UserContext";
import { postsAPI } from "../../services/api";
import Toast from "../Toast";
import Loader from "../Loader";
import "../../styles/Location.css";
import { Icon } from "leaflet";
const customIcon = new Icon({
  iconUrl: "https://cdn-icons-png.flaticon.com/512/447/447031.png",
  iconSize: [38, 38], // size of the icon
});

const AddSighting = () => {
  const { userData } = useContext(UserContext);
  const { user, token } = userData;
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState("");
  const [marker, setMarker] = useState({ lat: "", lng: "" });
  const [isverified, setIsVerified] = useState(false);
  const [submit, setSubmit] = useState("Submit");
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(null);

  const AddMarkerToClick = () => {
    useMapEvents({
      click(e) {
        const newMarker = e.latlng;
        setMarker(newMarker);
      },
    });

    return (
      <>
        {marker && (
          <Marker position={marker} icon={customIcon}>
            <Popup>{`Latitude: ${marker.lat}, Longitude: ${marker.lng}`}</Popup>
          </Marker>
        )}
      </>
    );
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!marker.lat || !marker.lng) {
      setToast({ message: "Please select a location on the map or enter coordinates", type: 'warning' });
      return;
    }

    if (!title || !description || !category) {
      setToast({ message: "Please fill in all required fields", type: 'warning' });
      return;
    }

    try {
      setLoading(true);
      setSubmit("Submitting...");
      setToast({ message: "Creating location...", type: 'info' });
      
      const data = {
        title,
        description,
        category,
        location: {
          latitude: parseFloat(marker.lat),
          longitude: parseFloat(marker.lng),
        },
        user: user.id,
        username: user.username,
        isverified,
      };
      
      await postsAPI.createPost(token, data);
      
      // Clear form
      setTitle("");
      setDescription("");
      setCategory("");
      setMarker({ lat: "", lng: "" });
      setIsVerified(false);
      
      setToast({ message: "Location Created Successfully! ✅", type: 'success' });
      setSubmit("Submit");
    } catch (error) {
      console.error("Error creating location:", error);
      setToast({ message: `Failed to create location: ${error.message}`, type: 'error' });
      setSubmit("Submit");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user.isAdmin) {
      setIsVerified(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <form onSubmit={handleSubmit} className={styles.form}>
      <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>🚛 Add New Truck Stop / Rest Area</h2>
      
      <label className={styles.label}>
        Location Name:
        <input
          type="text"
          value={title}
          onChange={(event) => setTitle(event.target.value)}
          required
          className={styles.input}
          placeholder="e.g., Love's Travel Stop, Pilot Flying J"
        />
      </label>
      <br />
      <label className={styles.label}>
        Description:
        <textarea
          value={description}
          onChange={(event) => setDescription(event.target.value)}
          required
          className={styles.textarea}
          placeholder="Describe the facilities, amenities, services available..."
          rows={4}
        />
      </label>
      <br />
      <label className={styles.label}>
        Category:
        <select
          value={category}
          onChange={(event) => setCategory(event.target.value)}
          required
          className={styles.select}
        >
          <option value="">--Please choose an option--</option>
          <option value="TRUCK_STOPS">🚛 TRUCK STOPS</option>
          <option value="REST_AREAS">🛣️ REST AREAS</option>
          <option value="OTHER">📍 OTHER</option>
        </select>
      </label>
      <div style={{ marginTop: '20px', marginBottom: '10px' }}>
        <strong>📍 Select Location:</strong> Click on the map or enter coordinates manually
      </div>
      
      <label className={styles.label}>
        Latitude:
        <input
          type="number"
          step="any"
          value={marker.lat}
          onChange={(event) =>
            setMarker((prevMarker) => ({
              ...prevMarker,
              lat: event.target.value,
            }))
          }
          required
          className={styles.input}
          placeholder="e.g., 40.7128"
        />
      </label>
      <label className={styles.label}>
        Longitude:
        <input
          type="number"
          step="any"
          value={marker.lng}
          onChange={(event) =>
            setMarker((prevMarker) => ({
              ...prevMarker,
              lng: event.target.value,
            }))
          }
          required
          className={styles.input}
          placeholder="e.g., -74.0060"
        />
      </label>
      
      <div style={{ height: '400px', marginTop: '20px', marginBottom: '20px' }}>
        <MapContainer 
          center={[40.712088496466265, -74.00615319746703]} 
          zoom={12}
          style={{ height: '100%', width: '100%' }}
        >
          <TileLayer
            attribution='© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <AddMarkerToClick />
        </MapContainer>
      </div>
      <br />

      <br />
      <button 
        type="submit" 
        className={styles.button}
        disabled={loading}
      >
        {submit}
      </button>
      
      {loading && <Loader />}
      {toast && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={() => setToast(null)}
        />
      )}
    </form>
  );
};

export default AddSighting;
